// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767px) {.mobile_hide {\n      display: none !important\n  }\n    }\n  .mobile__bg {\n    position: fixed;\n    z-index: 150;\n    top: 0;\n    left: 0;\n    display: none;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, .8);\n  }\n  .mobile__bg_show {\n      display: block;\n    }\n  @media (min-width: 1024px) {\n  .mobile__bg_show {\n        display: none\n    }\n      }\n", ""]);
// Exports
module.exports = exports;
